<evc-menu position="bottom-right">
    <evc-button trigger evcMenuTriggerState type="neutral" frame="ghost" label="Inspection setup">
        <evc-icon icon="setting" size="sm"></evc-icon>
    </evc-button>

    <button type="button" class="inspection-setup__popover" (click)="openModal()">
        <div class="inspection-setup__popover-body">
            <evc-icon icon="info-line" size="sm"></evc-icon>
            <div class="inspection-setup__popover-details">
                <span>Inspection Setup</span>
                <ng-container *ngIf="version">
                    <span>Version: {{ version.version }}</span>
                    <span class="inspection-setup__popover-updated">Updated: {{ version.timestamp | date: 'MMMM d, y' }} at {{ version.timestamp | date: 'h:mm a' }}</span>
                </ng-container>
            </div>
        </div>
    </button>
</evc-menu>